<template>
  <article class="article">
    <a
      :href="`${baseURL}/handle/${publication.handle}`"
      class="image-link"
      target="_blank"
    >
      <img
        class="article__thumb thumbnail"
        alt="Thumbnail"
        :src="getThumbnailUrl()"
      />
    </a>
    <div class="article__info">
      <h5 class="article__title">
        <a
          :href="`${baseURL}/handle/${publication.handle}`"
          target="_blank"
          :title="publication.name"
          >{{ publication.name }}</a
        >
      </h5>
      <p class="article__abstract">
        {{
          publication.metadata.find(
            (meta) => meta.key == "dc.description.abstract",
          ).value
        }}
      </p>
      <Button
        :href="`${baseURL}/handle/${publication.handle}`"
        target="_blank"
        theme="primary"
      >
        Seguir Leyendo
      </Button>
    </div>
  </article>
</template>
<script>
import Button from "@/components/ui/atoms/Button";
export default {
  components: {
    Button,
  },
  props: {
    publication: {
      type: Object,
      default: () => {},
    },
  },
  setup(props) {
    const baseURL = "https://repositorio.igp.gob.pe";

    const getThumbnailUrl = () => {
      const thumbnail = props.publication.bitstreams?.find(
        (bitstream) => bitstream.bundleName == "THUMBNAIL",
      );

      if (!thumbnail) return "";

      const retrieveLink = thumbnail.retrieveLink;

      // Si ya es una URL completa, usarla directamente
      if (retrieveLink?.startsWith("http")) {
        return retrieveLink;
      }

      // Si es un path relativo, construir la URL
      return `${baseURL}/rest${retrieveLink}`;
    };

    return {
      baseURL,
      getThumbnailUrl,
    };
  },
};
</script>
<style lang="scss" scoped>
.article {
  display: flex;
  justify-content: space-between;
  grid-gap: 1em;
  &__thumb {
    height: 130px;
    max-width: 95px;
    width: 95px;
  }
  &__title {
    margin-bottom: 0.5rem;
    a {
      display: -webkit-box;
      -webkit-line-clamp: 1;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  &__abstract {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    margin-bottom: 0.8em;
  }
}
</style>
